import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { clientConfigurationProvider as getConfigValue } from '@ocean/configs'
import { apiMiddleware } from 'api'
import createRootReducer from './rootReducer'

export const history = createBrowserHistory({
  basename: getConfigValue('baseName') as string,
})

// Used in e2e tests
;(window as any).__router__ = history

const rootReducer = createRootReducer(history)

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => [
    apiMiddleware,
    ...getDefaultMiddleware({ serializableCheck: false }),
    routerMiddleware(history),
  ],
})

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default
    store.replaceReducer(newRootReducer)
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export default store
